module.exports = __webpack_public_path__ + "static/backgroundYellow-74fc1e25e29c4d5b6da3c661d50f4ac4.png";